import * as React from "react";

function Fall(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={21} height={20} fill="none" {...props}>
      <path
        d="M1.443 1l5.375 9.813 3.706-4.293 4.819 7.565"
        stroke="#939393"
        strokeWidth={2}
      />
      <path
        d="M17.492 12.259l.397 5.997-5.11-2.864 4.713-3.133z"
        fill="#939393"
      />
    </svg>
  );
}

const MemoFall = React.memo(Fall);
export default MemoFall;
